// management/* page translations
const management = {
  factoryList: {
    label: {
      status: 'Trạng thái',
    },
    status: {
      all: 'Tất cả',
      normal: 'Bình thường',
      warning: 'Cảnh báo',
      error: 'Bất thường',
    },
    searchPlaceholder: 'Tìm theo tên hoặc mã nhà máy',
    addBtn: 'Thêm nhà máy',
    loading: 'Đang tải dữ liệu...',
    col: {
      name: 'Tên nhà máy',
      code: 'Mã',
      location: 'Vị trí',
      temperature: 'Nhiệt độ',
      humidity: 'Độ ẩm',
      equipmentStatus: 'Tình trạng thiết bị',
      operationRate: 'Tỉ lệ vận hành',
      status: 'Trạng thái',
      lastInspection: 'Kiểm tra gần nhất',
      action: 'Thao tác',
    },
    manager: 'Phụ trách: {manager}',
    equipmentTotal: 'Tổng {total}',
    equipmentRunning: 'Đang chạy {running}',
    equipmentIdle: 'Chờ {idle}',
    equipmentStopped: 'Dừng {stopped}',
    deleteModal: {
      title: 'Xóa nhà máy',
      message: 'Xóa nhà máy "{name}"?\nThao tác này không thể hoàn tác.',
      confirm: 'Xóa',
      cancel: 'Hủy',
    },
    alertDeleted: 'Đã xóa nhà máy "{name}".',
    alertDeleteFail: 'Xóa nhà máy thất bại.',
  },
  factoryRegister: {
    section: {
      basic: 'Thông tin cơ bản',
      manager: 'Thông tin người phụ trách',
    },
    label: {
      name: 'Tên nhà máy',
      code: 'Mã nhà máy',
      location: 'Vị trí',
      address: 'Địa chỉ chi tiết',
      managerName: 'Tên người phụ trách',
      contact: 'Liên hệ',
      email: 'Email',
      description: 'Ghi chú',
    },
    placeholder: {
      name: 'Nhập tên nhà máy',
      code: 'VD: SEL-001',
      location: 'VD: Geumcheon-gu, Seoul',
      address: 'Nhập địa chỉ chi tiết',
      managerName: 'Nhập tên người phụ trách',
      contact: '010-0000-0000',
      email: 'example@company.com',
      description: 'Nhập mô tả thêm',
    },
    btn: {
      cancel: 'Hủy',
      submit: 'Đăng ký nhà máy',
    },
    alertSuccess: 'Đã đăng ký nhà máy thành công.',
    alertDuplicate: 'Mã nhà máy đã tồn tại. Vui lòng sử dụng mã khác.',
    alertFail: 'Đăng ký nhà máy thất bại. Vui lòng kiểm tra thông tin nhập.',
  },
  factoryDetail: {
    title: 'Chi tiết nhà máy',
    loading: 'Đang tải dữ liệu...',
    section: {
      basic: 'Thông tin cơ bản',
      manager: 'Thông tin người phụ trách',
      operation: 'Thông tin vận hành',
      environment: 'Thông tin môi trường',
    },
    label: {
      name: 'Tên nhà máy',
      code: 'Mã nhà máy',
      location: 'Vị trí',
      address: 'Địa chỉ chi tiết',
      managerName: 'Tên người phụ trách',
      contact: 'Liên hệ',
      email: 'Email',
      totalEquipment: 'Tổng số thiết bị',
      running: 'Đang chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      status: 'Trạng thái',
      description: 'Ghi chú',
      temperature: 'Nhiệt độ hiện tại',
      humidity: 'Độ ẩm hiện tại',
      totalEquipmentShort: 'Tổng thiết bị',
      operationRate: 'Tỉ lệ vận hành',
      establishedDate: 'Ngày thành lập',
      lastInspection: 'Kiểm tra gần nhất',
    },
    status: {
      normal: 'Bình thường',
      warning: 'Cảnh báo',
      error: 'Bất thường',
    },
    unit: {
      count: '{n}',
    },
    btn: {
      delete: 'Xóa',
      edit: 'Sửa',
      cancel: 'Hủy',
      save: 'Lưu',
    },
    alertLoadFail: 'Tải thông tin nhà máy thất bại.',
    alertUpdateSuccess: 'Đã cập nhật thông tin nhà máy thành công.',
    alertUpdateFail: 'Cập nhật thông tin nhà máy thất bại.',
    confirmDelete: 'Bạn có chắc chắn muốn xóa nhà máy này?\nDữ liệu đã xóa không thể khôi phục.',
    alertDeleteSuccess: 'Đã xóa nhà máy thành công.',
    alertDeleteFail: 'Xóa nhà máy thất bại.',
  },
  equipmentList: {
    loading: 'Đang tải dữ liệu...',
    label: {
      factory: 'Nhà máy',
      line: 'Dây chuyền',
      status: 'Trạng thái',
    },
    statusOption: {
      all: 'Tất cả',
      running: 'Đang chạy',
      idle: 'Chờ',
      maintenance: 'Bảo trì',
      fault: 'Hỏng',
    },
    status: {
      running: 'Đang chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      maintenance: 'Bảo trì',
      fault: 'Hỏng',
      offline: 'Ngoại tuyến',
    },
    searchPlaceholder: 'Tìm theo tên hoặc model thiết bị',
    addBtn: 'Thêm thiết bị',
    col: {
      name: 'Tên thiết bị',
      model: 'Model',
      factory: 'Nhà máy',
      line: 'Dây chuyền',
      manufacturer: 'Nhà sản xuất',
      serialNumber: 'Số sê-ri',
      status: 'Trạng thái',
      maxTemperature: 'Nhiệt độ tối đa',
      maxPressure: 'Áp suất tối đa',
      cycleTime: 'Thời gian chu kỳ',
      cavity: 'Cavity',
      lastInspection: 'Kiểm tra',
      action: 'Thao tác',
    },
    deleteModal: {
      title: 'Xóa thiết bị',
      message: 'Xóa thiết bị "{name}"?\nThao tác này không thể hoàn tác.',
      confirm: 'Xóa',
      cancel: 'Hủy',
    },
    alertDeleted: 'Đã xóa thiết bị "{name}".',
    alertDeleteFail: 'Xóa thiết bị thất bại.',
  },
  equipmentRegister: {
    section: {
      basic: 'Thông tin cơ bản',
      spec: 'Thông số kỹ thuật',
    },
    label: {
      equipmentCode: 'Mã thiết bị',
      equipmentName: 'Tên thiết bị',
      model: 'Model',
      factory: 'Nhà máy',
      line: 'Dây chuyền',
      manufacturer: 'Nhà sản xuất',
      serialNumber: 'Số sê-ri',
      installDate: 'Ngày lắp đặt',
      warrantyEndDate: 'Ngày hết bảo hành',
      initialStatus: 'Trạng thái ban đầu',
      maxTemperature: 'Nhiệt độ tối đa (°C)',
      maxPressure: 'Áp suất tối đa (MPa)',
      ratedPower: 'Công suất định mức (kW)',
      targetCycleTime: 'Thời gian chu kỳ mục tiêu (giây)',
      cavityCount: 'Số cavity',
      lastInspectionDate: 'Ngày kiểm tra cuối',
      nextMaintenanceDate: 'Ngày bảo trì kế tiếp',
      description: 'Ghi chú',
    },
    placeholder: {
      equipmentCode: 'VD: E001',
      equipmentName: 'VD: Máy ép phun #1',
      model: 'VD: LS-350H',
      factorySelect: 'Chọn nhà máy',
      lineSelect: 'Chọn dây chuyền (chưa gán)',
      manufacturer: 'Nhập tên nhà sản xuất',
      serialNumber: 'Nhập số sê-ri thiết bị',
      maxTemperature: 'VD: 350',
      maxPressure: 'VD: 180',
      ratedPower: 'VD: 35.0',
      targetCycleTime: 'VD: 45',
      cavityCount: 'VD: 4',
      description: 'Nhập mô tả thêm',
    },
    statusOption: {
      running: 'Đang chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      maintenance: 'Bảo trì',
      fault: 'Hỏng',
      offline: 'Ngoại tuyến',
    },
    btn: {
      cancel: 'Hủy',
      submit: 'Đăng ký thiết bị',
    },
    alertSuccess: 'Đã đăng ký thiết bị thành công.',
    alertDuplicate: 'Mã thiết bị đã tồn tại. Vui lòng sử dụng mã khác.',
    alertFail: 'Đăng ký thiết bị thất bại. Vui lòng kiểm tra thông tin nhập.',
  },
  equipmentDetail: {
    title: 'Chi tiết thiết bị',
    loading: 'Đang tải dữ liệu...',
    section: {
      basic: 'Thông tin cơ bản',
      spec: 'Thông số kỹ thuật',
    },
    label: {
      equipmentName: 'Tên thiết bị',
      equipmentCode: 'Mã thiết bị',
      model: 'Model',
      factory: 'Nhà máy',
      line: 'Dây chuyền',
      manufacturer: 'Nhà sản xuất',
      serialNumber: 'Số sê-ri',
      installDate: 'Ngày lắp đặt',
      warrantyEndDate: 'Ngày hết bảo hành',
      status: 'Trạng thái',
      maxTemperature: 'Nhiệt độ tối đa',
      maxPressure: 'Áp suất tối đa',
      ratedPower: 'Công suất định mức',
      targetCycleTime: 'Thời gian chu kỳ mục tiêu',
      cavityCount: 'Số cavity',
      lastInspectionDate: 'Ngày kiểm tra cuối',
      nextMaintenanceDate: 'Ngày bảo trì kế tiếp',
      description: 'Ghi chú',
      cavity: 'Cavity',
      targetCycle: 'Chu kỳ mục tiêu',
      lastInspection: 'Kiểm tra gần nhất',
    },
    placeholder: {
      lineSelect: 'Chưa gán dây chuyền',
    },
    statusOption: {
      running: 'Đang chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      maintenance: 'Bảo trì',
      fault: 'Hỏng',
      offline: 'Ngoại tuyến',
    },
    btn: {
      delete: 'Xóa',
      edit: 'Sửa',
      cancel: 'Hủy',
      save: 'Lưu',
    },
    alertLoadFail: 'Tải thông tin thiết bị thất bại.',
    alertUpdateSuccess: 'Đã cập nhật thông tin thiết bị thành công.',
    alertUpdateFail: 'Cập nhật thông tin thiết bị thất bại.',
    confirmDelete: 'Bạn có chắc chắn muốn xóa thiết bị này?',
    alertDeleteSuccess: 'Đã xóa thiết bị thành công.',
    alertDeleteFail: 'Xóa thiết bị thất bại.',
  },
  userList: {
    loading: 'Đang tải dữ liệu...',
    label: {
      role: 'Vai trò',
    },
    roleOption: {
      all: 'Tất cả',
      systemAdmin: 'Quản trị hệ thống',
      normalUser: 'Người dùng thường',
    },
    role: {
      superAdmin: 'Siêu quản trị',
      systemAdmin: 'Quản trị hệ thống',
      normalUser: 'Người dùng thường',
    },
    status: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
      locked: 'Đã khóa',
    },
    permissionLabel: {
      dashboard: 'Bảng điều khiển',
      monitoring: 'Giám sát',
      factory: 'QL nhà máy',
      equipment: 'QL thiết bị',
      user: 'QL người dùng',
      role: 'QL quyền hạn',
      system: 'QL hệ thống',
    },
    searchPlaceholder: 'Tìm theo tên hoặc email',
    addBtn: 'Thêm người dùng',
    col: {
      user: 'Người dùng',
      position: 'Chức vụ',
      department: 'Phòng ban',
      status: 'Trạng thái',
      lastLogin: 'Đăng nhập cuối',
      joinDate: 'Ngày tham gia',
      roleGroup: 'Nhóm quyền',
      permissions: 'Quyền hạn',
      action: 'Thao tác',
    },
    deleteModal: {
      title: 'Xóa người dùng',
      message: 'Xóa người dùng "{name}"?\nThao tác này không thể hoàn tác.',
      confirm: 'Xóa',
      cancel: 'Hủy',
    },
    alertDeleted: 'Đã xóa người dùng "{name}".',
    alertDeleteFail: 'Xóa người dùng thất bại.',
  },
  userRegister: {
    section: {
      basic: 'Thông tin cơ bản',
      organization: 'Thông tin tổ chức',
      permissions: 'Cài đặt quyền hạn',
    },
    label: {
      name: 'Tên',
      email: 'Email',
      password: 'Mật khẩu',
      confirmPassword: 'Xác nhận mật khẩu',
      phone: 'Điện thoại',
      department: 'Phòng ban',
      position: 'Chức vụ',
      status: 'Trạng thái tài khoản',
      roleGroup: 'Nhóm quyền',
    },
    placeholder: {
      name: 'Nhập tên người dùng',
      email: 'example@company.com',
      password: 'Nhập mật khẩu (8+ ký tự)',
      confirmPassword: 'Nhập lại mật khẩu',
      phone: '010-0000-0000',
      department: 'Nhập tên phòng ban',
      position: 'Nhập chức vụ',
    },
    statusOption: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
    },
    permissionsNote: '(Tự động thiết lập theo nhóm quyền đã chọn)',
    permissionsEmpty: 'Chọn nhóm quyền để hiển thị thông tin quyền hạn.',
    permissionCategoryEtc: 'Khác',
    btn: {
      cancel: 'Hủy',
      submit: 'Đăng ký người dùng',
    },
    alertPasswordMismatch: 'Mật khẩu không khớp.',
    alertSuccess: 'Đã đăng ký người dùng.',
    alertFail: 'Đăng ký người dùng thất bại. Vui lòng thử lại.',
    alertRoleGroupFail: 'Tải danh sách nhóm quyền thất bại.',
  },
  userDetail: {
    title: 'Chi tiết người dùng',
    loading: 'Đang tải dữ liệu...',
    notFound: 'Không tìm thấy thông tin người dùng.',
    section: {
      basic: 'Thông tin cơ bản',
      organization: 'Thông tin tổ chức',
      permissions: 'Cài đặt quyền hạn',
    },
    label: {
      name: 'Tên',
      email: 'Email',
      newPassword: 'Mật khẩu mới',
      confirmPassword: 'Xác nhận mật khẩu',
      phone: 'Điện thoại',
      department: 'Phòng ban',
      position: 'Chức vụ',
      status: 'Trạng thái tài khoản',
      roleGroup: 'Nhóm quyền',
      joinDate: 'Ngày tham gia',
      lastLogin: 'Đăng nhập cuối',
    },
    placeholder: {
      newPassword: 'Chỉ nhập khi đổi mật khẩu',
      confirmPassword: 'Nhập lại mật khẩu',
      phone: '010-1234-5678',
      department: 'VD: Hỗ trợ quản lý',
      position: 'VD: Quản lý',
    },
    statusOption: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
      locked: 'Đã khóa',
    },
    status: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
      locked: 'Đã khóa',
    },
    permissionsNote: ' (Tự động thiết lập theo nhóm quyền)',
    permissionsEmpty: 'Chưa cấu hình quyền hạn.',
    permissionCategoryEtc: 'Khác',
    btn: {
      delete: 'Xóa',
      edit: 'Sửa',
      cancel: 'Hủy',
      save: 'Lưu',
    },
    alertPasswordMismatch: 'Mật khẩu không khớp.',
    alertLoadFail: 'Tải thông tin người dùng thất bại.',
    alertUpdateSuccess: 'Đã cập nhật thông tin người dùng.',
    alertUpdateFail: 'Cập nhật thông tin người dùng thất bại.',
    confirmDelete: 'Bạn có chắc chắn muốn xóa người dùng này?\nThao tác này không thể hoàn tác.',
    alertDeleteSuccess: 'Đã xóa người dùng.',
    alertDeleteFail: 'Xóa người dùng thất bại.',
  },
};

export default management;
